/** Active queue statuses (Chat Operations — not archived). */
export const ACTIVE_CHAT_STATUSES = ['open', 'active', 'pending', 'awaiting_customer'];

/** Archived / ended sessions. */
export const CLOSED_CHAT_STATUSES = ['closed', 'resolved'];

/** Zendesk-style "Marked as" actions for agents. */
export const CHAT_MARK_AS_OPTIONS = [
  { value: 'pending', label: 'Pending' },
  { value: 'awaiting_customer', label: 'Awaiting Customer' },
  { value: 'resolved', label: 'Resolved' },
  { value: 'resolved_create_ticket', label: 'Resolved & Create Ticket' },
];

/**
 * @param {string | null | undefined} status
 */
export function isActiveChatStatus(status) {
  return typeof status === 'string' && ACTIVE_CHAT_STATUSES.includes(status);
}

/**
 * @param {string | null | undefined} status
 */
export function isClosedChatStatus(status) {
  return typeof status === 'string' && CLOSED_CHAT_STATUSES.includes(status);
}

/**
 * @param {string | null | undefined} status
 */
export function chatStatusLabel(status) {
  const found = CHAT_MARK_AS_OPTIONS.find((opt) => opt.value === status);
  if (found) return found.label;
  if (status === 'open' || status === 'active') return 'Open';
  if (status === 'closed') return 'Closed';
  if (status === 'resolved') return 'Resolved';
  return status || 'Open';
}

/**
 * @param {Record<string, unknown> | null | undefined} session
 */
export function wasClosedByAgent(session) {
  if (!session || !isClosedChatStatus(session.status)) return false;
  if (session.closedBy === 'visitor') return false;
  return Boolean(session.resolvedBy || session.resolvedByUid || session.closedBy === 'agent');
}
